<template>
  <div>
    <chartjs-pie-card
      v-if="dataIsNotEmpty"
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <div class="d-flex">
          <div class="card-title diligencePieChartTitle">Rights</div>
          <div
            style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
            v-tooltip.top-end="toolTipInfo"
          >
            <img src="static/img/graphInfo.svg" class />
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import { vals, formatCurrency, subsetBackground } from "../../../util";
import { ChartjsPieCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
export default {
  name: "pie-proRata-chart-card",
  components: {
    [ChartjsPieCard.name]: ChartjsPieCard,
  },
  props: {
    cutoutPercentage: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      textCenterLabel: [],
      chartColors: {
        prorata: "#0031FF",
        leadInvestor: "#7CD500",
        boardSeat: "#2DB6FE",
        informationRights: "#C767DC",
      },
    };
  },
  computed: {
    ...mapGetters("investment", ["proRataChartData"]),
    ...mapGetters("investment", ["showProRataChart"]),
    chartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset,
      };
      return data;
    },
    chartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: this.cutoutPercentage,
        plugins: {
          doughnutlabel: {
            labels: this.textCenterLabel,
          },
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].toolTip_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                (data.datasets[toolTipItem.datasetIndex].data[
                  toolTipItem.index
                ] || "") +
                "%"
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].data_value[
                  toolTipItem.index
                ] || 0;
              return value > 1 ? `${value} Companies` : `${value} Company`;
            },
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            padding: 20,
          },
        },
        onClick: function (unused, toolTips) {
          let toolTipItem = toolTips[0];
          if (!_.isNil(toolTipItem)) {
            if (toolTipItem._datasetIndex === 0) {
              // only 'drill-down' if it is a primary value
              let data = toolTipItem._chart.data;
              let propertyValue =
                data.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              self.addDatasetForProperty(propertyValue, toolTipItem._index);
              let rightsDataValue =
                data.datasets[toolTipItem._datasetIndex].data_value[
                  toolTipItem._index
                ];
              let obj = {
                text: propertyValue,
                font: {
                  size: "12",
                  family: "custom-helvetica-medium,roboto",
                },
                color: "#050505",
              };
              let dataObj = {
                text: rightsDataValue,
                font: {
                  size: "25",
                  family: "custom-helvetica-medium,roboto",
                },
                color: "#050505",
              };
              self.textCenterLabel[0] = obj;
              self.textCenterLabel[1] = dataObj;
            } else if (toolTipItem._datasetIndex === 1) {
              // second tier
              // if label has 'Other' then we want to show table data
              let drillData = toolTipItem._chart.data;
              let drillPropertyValue =
                drillData.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              // make sure we have a path and that the path has 'Other' as its leaf
              if (drillPropertyValue.includes("/")) {
                let split = drillPropertyValue.split("/");
                let drillCompanyData = self.proRataChartData[split[0].trim()];
                let actualCompany = drillCompanyData.find((item) => {
                  if (item.name == split[1].trim()) {
                    return item;
                  }
                });
                let account_id = self.$route.params.account_id;
                let workspace_id = self.$route.params.workspace_id;
                let ucid = actualCompany.ucid;
                self.$store.commit("temp/currentCompany", ucid);
                self.$router.push(
                  `/${account_id}/${workspace_id}/companyProfile/${ucid}`
                );
              }
            }
          }
        },
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    dataIsNotEmpty() {
      return this.showProRataChart;
    },
    toolTipInfo() {
      return "Shows the number of companies in your portfolio where you have Pro Rata rights, are a Lead Investor or have a board seat";
    },
  },
  methods: {
    createPrimaryDataset() {
      const self = this;
      // only do check if there is data (and it is local)
      if (!self.showProRataChart) return;
      // do initial calculate for chart data
      let labels = [];
      let backgroundColors = [];
      let values = [];
      let values_p = [];
      let tooltipLabels = [];
      if (
        self.proRataChartData &&
        self.proRataChartData.prorata &&
        self.proRataChartData.prorata.length > 0
      ) {
        labels.push("Pro Rata");
        values.push(self.proRataChartData.prorata.length);
        values_p.push(
          (
            (self.proRataChartData.prorata.length /
              (self.proRataChartData.prorata.length +
                self.proRataChartData.leadInvestor.length +
                self.proRataChartData.boardSeat.length +
                self.proRataChartData.informationRights.length)) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#0031FF");
      }
      if (
        self.proRataChartData &&
        self.proRataChartData.leadInvestor &&
        self.proRataChartData.leadInvestor.length > 0
      ) {
        labels.push("Lead Investor");
        values.push(self.proRataChartData.leadInvestor.length);
        values_p.push(
          (
            (self.proRataChartData.leadInvestor.length /
              (self.proRataChartData.prorata.length +
                self.proRataChartData.leadInvestor.length +
                self.proRataChartData.boardSeat.length +
                self.proRataChartData.informationRights.length)) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#7CD500");
      }
      if (
        self.proRataChartData &&
        self.proRataChartData.boardSeat &&
        self.proRataChartData.boardSeat.length > 0
      ) {
        labels.push("Board Seat");
        values.push(self.proRataChartData.boardSeat.length);
        values_p.push(
          (
            (self.proRataChartData.boardSeat.length /
              (self.proRataChartData.prorata.length +
                self.proRataChartData.leadInvestor.length +
                self.proRataChartData.boardSeat.length +
                self.proRataChartData.informationRights.length)) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#2DB6FE");
      }
      if (
        self.proRataChartData &&
        self.proRataChartData.informationRights &&
        self.proRataChartData.informationRights.length > 0
      ) {
        labels.push("Information Rights");
        values.push(self.proRataChartData.informationRights.length);
        values_p.push(
          (
            (self.proRataChartData.informationRights.length /
              (self.proRataChartData.prorata.length +
                self.proRataChartData.leadInvestor.length +
                self.proRataChartData.boardSeat.length +
                self.proRataChartData.informationRights.length)) *
            100
          ).toFixed(2)
        );
        backgroundColors.push("#C767DC");
      }
      self.datasets = [];
      self.labels = [];
      self.labels = labels;
      self.datasets.push({
        header_label: labels,
        data: values_p,
        data_value: values,
        backgroundColor: backgroundColors,
        toolTip_label: labels,
      });
    },
    addDatasetForProperty(value, index) {
      let valueModified;
      if (value == "Pro Rata") {
        valueModified = "prorata";
      }
      if (value == "Lead Investor") {
        valueModified = "leadInvestor";
      }
      if (value == "Board Seat") {
        valueModified = "boardSeat";
      }
      if (value == "Information Rights") {
        valueModified = "informationRights";
      }
      const self = this;
      let values = self.proRataChartData[valueModified];
      let finalObj = { value: [], value_p: [], names: [] };
      let bgColors = [];
      values.map((item) => {
        finalObj.value.push(1);
        finalObj.value_p.push(((1 / values.length) * 100).toFixed(2));
        finalObj.names.push(item.name);
        bgColors.push(self.chartColors[valueModified]);
      });
      //if (index > 9) index = index - 10;
      //let bgColors = _.concat(subsetBackground(index), subsetBackground(index));
      // if (values.length <= bgColors.length) {
      //   // we want 'other' to be grey (default color) - remove colors so that other is 'empty'
      //   bgColors = _.slice(bgColors, 0, values.length - 1);
      // }
      // create the dataset...
      let dataset = {
        header_label: _.map(finalObj.names, (n) => {
          return valueModified + " / " + n;
        }),
        toolTip_label: _.map(finalObj.names, (n) => {
          return value + " / " + n;
        }),
        data: finalObj.value_p,
        data_value: finalObj.value,
        backgroundColor: bgColors,
      };
      // if there is already a second dataset, remove it
      if (self.datasets.length > 1)
        self.datasets = _.slice(self.datasets, 0, 1);
      // add new one
      self.datasets.push(dataset);
      self.datasets = _.without(self.datasets, undefined, null);
    },
  },
  mounted() {
    this.$store
      .dispatch("investment/getProRataData")
      .then((data) => {
        this.$store.getters["investment/proRataChartData"];
        this.$store.getters["investment/showProRataChart"];
        if (this.showProRataChart) {
          this.createPrimaryDataset();
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  },
  watch: {
    showProRataChart: {
      handler(newData) {
        // updated portfolio, run update
        if (newData) this.createPrimaryDataset();
      },
    },
  },
};
</script>